module.exports = __webpack_public_path__ + "static/media/nlsreceipt.9118efa5.svg";